/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Teams_Settings_Contact_Extend_Wrapup_SecondsInputs */

const en_forms_teams_settings_contact_extend_wrapup_seconds = /** @type {(inputs: Forms_Teams_Settings_Contact_Extend_Wrapup_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wrapup Seconds`)
};

const de_forms_teams_settings_contact_extend_wrapup_seconds = /** @type {(inputs: Forms_Teams_Settings_Contact_Extend_Wrapup_SecondsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extend Wrapup Seconds`)
};

/**
* | output |
* | --- |
* | "Wrapup Seconds" |
*
* @param {Forms_Teams_Settings_Contact_Extend_Wrapup_SecondsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_teams_settings_contact_extend_wrapup_seconds = /** @type {((inputs?: Forms_Teams_Settings_Contact_Extend_Wrapup_SecondsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Teams_Settings_Contact_Extend_Wrapup_SecondsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_teams_settings_contact_extend_wrapup_seconds(inputs)
	return de_forms_teams_settings_contact_extend_wrapup_seconds(inputs)
});